<template>
    <div>
        <v-progress-circular
            v-if="isLoading"
            class="progress-spinner"
            :size="40"
            indeterminate
            color="primary" />
        <v-file-input
            v-else
            outlined
            dense
            prepend-icon="mdi-plus"
            v-bind="$attrs"
            @change="addFile" />
    </div>
</template>

<script>
import { add } from '@/features/schemas/services/schemaApi';
export default{
    props: {
        scope: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            isLoading: false
        }
    },

    methods: {
        async addFile(file) {
            this.isLoading = true;
            if(!file) {
                return;
            }

            let formData = new FormData();
            formData.append("file", file);

            let response = await add("file", this.scope, formData)
            this.$emit('input', response);
            this.isLoading = false;
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/styles/theme.scss";

.file-input {
    border: 0.0625rem solid $color-grey-dark;
    border-radius: 0.25rem;
    padding-top: 0;
    padding-left: 0.5rem;
}

.progress-spinner{
    position: absolute;
    top: calc(50% - 1.25rem);
    left: calc(50% - 1.25rem);
}
</style>
